// Leituras do editor usam os contratos existentes, sem repetição automática.
const recursos = {
  diverso: ["atendimentos/access/obterDiversos", "object"],
  revisar: ["modelosLaudos/access/revisarModelo", "object"],
  configuracoes: ["configuracoes/access/buscarConfiguracoesGerais", "array", "get"],
  medicos: ["staffMedicos/access/listarSimples", "array", "get"],
  contato: ["contatosExternos/access/obterSimples", "object"],
  modelos: ["staffMedicos/access/modelosLaudos", "array"],
  titulos: ["atendimentos/access/listarTitulosFrases", "array"],
  complementos: ["atendimentos/access/buscarComplementos", "array"],
  pendencias: ["atendimentos/access/listarPendencias", "array"],
  pacienteLaudo: ["atendimentos/access/obterLaudoPaciente", "object"],
  bloqueio: ["atendimentos/access/obterBloqueioLaudo", "object"],
  associacao: ["agendamentosFilaLaudo/access/obterLaudoAssociacao", "object"],
  logs: ["atendimentos/access/listarLogLaudo", "array"],
  log: ["atendimentos/access/obterLogLaudo", "object"],
  ultimo: ["atendimentos/access/obterUltimoDocumentoProduto", "object"],
  modelo: ["modelosLaudos/access/obterModeloComMacros", "object"],
  medicamentos: ["textos/access/listarTextosMedicamentos", "array"]
};
const objeto = value => value !== null && typeof value === "object" && !Array.isArray(value);
export async function consultarEditorTexto(api, jwt, { recurso, dados = {}, signal }) {
  if(!Object.prototype.hasOwnProperty.call(recursos, recurso)) { throw new Error("Leitura desconhecida."); }
  if(!jwt.getToken()) { throw new Error("Sessão indisponível."); }
  api.setHeader();
  const [url, tipo, metodo] = recursos[recurso];
  const config = { signal, timeout: 120000 };
  const { data } = metodo === "get" ? await api.query(url, config) : await api.postOnce(url, dados, config);
  if(tipo === "array" ? !Array.isArray(data) || data.some(item => !objeto(item)) : !objeto(data)) { throw new Error("Resposta inválida do editor."); }
  if(recurso === "modelos" && data.some(item => !Array.isArray(item.TEXTOS) || item.TEXTOS.some(row => !objeto(row)))) { throw new Error("Modelos inválidos."); }
  if(recurso === "titulos" && data.some(item => item.DESCRICAO && (!Array.isArray(item.FRASES) || item.FRASES.some(row => !objeto(row))))) { throw new Error("Frases inválidas."); }
  if((recurso === "modelo" || recurso === "revisar") && typeof data.TEXTO !== "string") { throw new Error("Modelo indisponível."); }
  if(recurso === "log" && (!data.ID_LAUDO_LOG || typeof data.ARQUIVO !== "string")) { throw new Error("Log indisponível."); }
  if(recurso === "bloqueio" && data.LOG && !Array.isArray(JSON.parse(data.LOG))) { throw new Error("Histórico de bloqueio inválido."); }
  return data;
}

export async function leiturasParalelasTexto(tarefas, vigente, cancelarPendentes = () => {}) {
  const resultados = {};
  let indice = 0, falha;
  const entradas = Object.entries(tarefas);
  await Promise.all(Array.from({ length: Math.min(4, entradas.length) }, async () => {
    while(!falha && vigente() && indice < entradas.length) {
      const [nome, ler] = entradas[indice++];
      try { resultados[nome] = await ler(); } catch(error) { if(!falha) { falha = error; cancelarPendentes(); } }
    }
  }));
  if(falha) { throw falha; }
  return resultados;
}

const editores = new WeakMap();
const contexto = vm => JSON.stringify([vm.$route.fullPath, vm.paciente.ID_PACIENTE, vm.idAtendimento,
  vm.agendaExame.ID_AGENDA_EXAME, vm.agendaExame.ID_PRODUTO, vm.textoIncluindo.ID, vm.textoIncluindo.ID_DIVERSOS]);
export function editorTexto(vm) {
  if(editores.has(vm)) { return editores.get(vm); }
  const canais = new Map();
  let versao = 0, encerrado = false;
  function cancelar(canal) {
    if(canal === undefined) {
      versao++;
      for(const nome of canais.keys()) { cancelar(nome); }
      return;
    }
    canais.get(canal)?.controller.abort();
    canais.delete(canal);
    delete vm.errosLeiturasTexto[canal];
    delete vm.leiturasTexto[canal];
  }
  function executar(canal, chave, trabalho, mensagem) {
    if(encerrado) { return Promise.resolve(false); }
    const anterior = canais.get(canal);
    if(anterior?.pendente && anterior.chave === chave && anterior.contexto === contexto(vm)) { return anterior.promise; }
    cancelar(canal);
    const req = { chave, contexto: contexto(vm), versao, controller: new AbortController(), pendente: true, repetivel: true };
    canais.set(canal, req);
    req.vigente = () => !encerrado && req.versao === versao && canais.get(canal) === req && req.contexto === contexto(vm);
    req.ler = (recurso, dados) => vm.consultarLeituraEditorTexto({ recurso, dados, signal: req.controller.signal });
    req.semRepeticao = () => { req.repetivel = false; };
    req.repetir = () => req.vigente() && req.repetivel && vm.errosLeiturasTexto[canal] ? executar(canal, chave, trabalho, mensagem) : Promise.resolve(false);
    vm.leiturasTexto[canal] = true;
    req.promise = Promise.resolve().then(async () => {
      try {
        if(!req.vigente()) { return false; }
        const resultado = await trabalho(req);
        return resultado !== false && req.vigente();
      } catch(error) {
        if(req.vigente()) { vm.errosLeiturasTexto[canal] = { mensagem, repetir: req.repetivel }; }
        return false;
      } finally {
        req.pendente = false;
        if(canais.get(canal) === req) { delete vm.leiturasTexto[canal]; }
      }
    });
    return req.promise;
  }
  const editor = {
    executar, cancelar,
    repetir: canal => canais.get(canal)?.repetir() || Promise.resolve(false),
    capturar: () => { const v = versao, c = contexto(vm); return () => !encerrado && v === versao && c === contexto(vm); },
    destruir: () => { cancelar(); encerrado = true; }
  };
  editores.set(vm, editor);
  return editor;
}
